
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SettingsList extends Vue {
  private settingsList = [
    {
      displayLabel: this.$t('preferences.notifications.shipments') as string,
      queryContent: 'shipments',
      icon: 'mdi-package-variant-closed',
    },
    {
      displayLabel: this.$t('preferences.notifications.packages') as string,
      queryContent: 'packages',
      icon: 'mdi-package-variant',
    },
    {
      displayLabel: this.$t('preferences.notifications.serviceAndPricing') as string,
      queryContent: 'serviceLevelAndPricing',
      icon: 'mdi-clock-time-nine',
    },
    {
      displayLabel: this.$t('preferences.notifications.customs') as string,
      queryContent: 'customs',
      icon: 'mdi-account-tie',
    },
    {
      displayLabel: this.$t('preferences.notifications.pickupOrDropOff') as string,
      queryContent: 'pickupOrDropOff',
      icon: 'mdi-truck',
    },
    {
      displayLabel: this.$t('preferences.notifications.general') as string,
      queryContent: 'general',
      icon: 'mdi-alert-circle',
    },
  ]
}
